import produce from "immer";
import { IStoreState } from "../../initialStoreState";

import { LoadState } from "../../../constants/enums";
import { initialTrialBalanceState } from "./TrialBalance.types";
import { TrialBalanceActions } from ".";
import { CLEAR_TRIAL_BALANCE, FETCH_TRIAL_BALANCE_LIST_FAILED, FETCH_TRIAL_BALANCE_LIST_PROGRESS, FETCH_TRIAL_BALANCE_LIST_SUCCESS } from "./TrialBalanceActions";

export const TrialBalanceReducer = (
  state: IStoreState["accounting"]["trialBalance"] = initialTrialBalanceState,
  action: TrialBalanceActions
) => {
  switch (action.type) {
    case FETCH_TRIAL_BALANCE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_TRIAL_BALANCE_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_TRIAL_BALANCE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }

    case CLEAR_TRIAL_BALANCE: {
      return initialTrialBalanceState;
    }

    default: {
      return state;
    }
  }
};
